export const Types = {
    SAVE_LIST_COMPANY: 'SAVE_LIST_COMPANY',
    SET_RECORD: 'SET_RECORD'
}